module.exports = __webpack_public_path__ + "assets/img/fuwu-bg.620b964c.png";